import React, { useState } from 'react';
import arcadeImage from '../img/arcade.jpg'; // Import the image
import ironmanHelmet1 from '../img/ironmanHelmetB.png'; // Import the first Ironman helmet image

function Projects({ id }) {
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const handleImageClick = (image) => {
    setFullscreenImage(image);
  };

  const handleCloseFullscreen = (event) => {
    if (event.target === event.currentTarget) {
      setFullscreenImage(null);
    }
  };

  return (
    <section id={id}>
      <h2>Hobbies</h2>
      <div className="projects-grid">
        <div className="project-card">
          <div className="project-card-image">
            <img
              src={ironmanHelmet1}
              alt="Ironman Helmet 1"
              onClick={() => handleImageClick(ironmanHelmet1)}
            />
            {fullscreenImage === ironmanHelmet1 && (
              <div className="fullscreen-image-container" onClick={handleCloseFullscreen}>
                <img src={ironmanHelmet1} alt="Ironman Helmet 1" className="fullscreen-image" />
              </div>
            )}
          </div>
          <h3>Ironman Helmet</h3>
          <p>
            Recreation of Ironman helmet using Raspberry Pi Zero, voice
            recognition, sound, LEDs, and servomotors (mainly using Python).
          </p>
        </div>
        <div className="project-card">
          <div className="project-card-image">
            <img
              src={arcadeImage}
              alt="Sega Arcade Machine"
              onClick={() => handleImageClick(arcadeImage)}
            />
            {fullscreenImage === arcadeImage && (
              <div className="fullscreen-image-container" onClick={handleCloseFullscreen}>
                <img src={arcadeImage} alt="Sega Arcade Machine" className="fullscreen-image" />
              </div>
            )}
          </div>
          <h3>Sega Arcade Machine</h3>
          <p>Sega arcade machine using Raspberry Pi 3 and Retropie.</p>
        </div>
        {/* Add more project cards */}
      </div>
    </section>
  );
}

export default Projects;
